import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { Button } from '@/components/shadcn/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
import { RestSchemas, useRestClient } from '@/contexts/QueryProvider'
import { IconMenuOutline } from '@icons/IconMenuOutline'
import { toast } from 'sonner'
import { WorkspaceSettingForm } from '../../Forms/WorkspaceSettingForm'
import { useCurrentWorkspace } from '../../useCurrentWorkspace'

type WorkspaceSetting = RestSchemas['Messages.Workspaces.WorkspaceSetting']

export function RowActionsMenu({ row }: { row: WorkspaceSetting }) {
  const { workspaceId } = useCurrentWorkspace()
  const { deleteWorkspacesApiDeleteWorkspaceSetting, getWorkspacesApiGetWorkspaceSettings } = useRestClient()

  const { mutate: deleteSetting } = deleteWorkspacesApiDeleteWorkspaceSetting.useMutation(undefined, {
    onSuccess: () => {
      getWorkspacesApiGetWorkspaceSettings.invalidateQueries({
        parameters: {
          query: { workspaceId },
        },
      })
      toast.success('Workspace setting deleted')
    },
    onError: () => {
      toast.error('Failed to delete workspace setting')
    },
  })

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon" className="size-8 rounded-full">
          <IconMenuOutline size={16} />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuLabel>Actions</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <WorkspaceSettingForm
          selectedSetting={row}
          sheetTitle="Edit setting"
          sheetTrigger={<DropdownMenuItem onSelect={(e) => e.preventDefault()}>Edit setting</DropdownMenuItem>}
        />
        <ConfirmDialog
          title="Delete setting"
          description="Are you sure you want to delete this setting?"
          onConfirm={() =>
            deleteSetting({
              query: { workspaceId, key: row.key ?? '' },
            })
          }
          trigger={
            <DropdownMenuItem onSelect={(e) => e.preventDefault()} disabled={!row.key}>
              Delete setting
            </DropdownMenuItem>
          }
        />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
